if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    show(opener) {
      super.show(opener);
      this.content = this.querySelector('.product-media-modal__content');
      this.showActiveMedia();
      this.initCustomNavigation();
    }

    showActiveMedia() {
      const targetMediaId = this.openedBy.getAttribute('data-media-id');
      const target = this.content?.querySelector(`[data-media-id="${targetMediaId}"]`) || 
                     this.content?.querySelector(`[id$="${targetMediaId}"]`);
      
      if (!target || !this.content) return;

      setTimeout(() => {
        this.content.scrollTo({
          left: target.offsetLeft,
          behavior: 'auto'
        });
      }, 100);

      const activeMediaTemplate = target.querySelector('template');
      if (target.nodeName === 'DEFERRED-MEDIA' && activeMediaTemplate) {
        target.loadContent();
      }
    }

    initCustomNavigation() {
      if (this.navInitialized) return;

      const nextBtn = this.querySelector('.modal-nav-button.next');
      const prevBtn = this.querySelector('.modal-nav-button.prev');

      // 核心修复函数：同时阻止点击和鼠标抬起事件的冒泡
      const handleNavigation = (direction, e) => {
        e.preventDefault();
        e.stopPropagation(); // 阻止 click 事件冒泡
        if (this.content) {
          const amount = direction === 'next' ? this.content.clientWidth : -this.content.clientWidth;
          this.content.scrollBy({ left: amount, behavior: 'smooth' });
        }
      };

      // 关键修复：阻止 pointerup 事件冒泡，防止触发 ModalDialog 的自动关闭逻辑
      const preventModalClose = (e) => {
        e.stopPropagation(); 
      };

      if (nextBtn) {
        nextBtn.addEventListener('click', (e) => handleNavigation('next', e));
        nextBtn.addEventListener('pointerup', preventModalClose); // 拦截抬起事件
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', (e) => handleNavigation('prev', e));
        prevBtn.addEventListener('pointerup', preventModalClose); // 拦截抬起事件
      }

      this.navInitialized = true;
    }
  });
}